import { RTC_PROVIDERS } from '../../../providerIds'
import { createDailyRtcPortBundle } from './createDailyRtcPortBundle'
import {
  createDailyRtcAdapterCapabilities,
  createDailyRtcCompatibilityProps,
  DailyRtcCompatibilitySurface,
  preloadDailyRtcModule,
} from './dailyRtcCompat'
import {
  DAILY_RTC_SESSION_EVENTS,
  createDailyRtcSessionHandle,
} from './createDailyRtcSessionHandle'

export { DAILY_RTC_SESSION_EVENTS } from './createDailyRtcSessionHandle'
export { createDailyRtcSessionHandle } from './createDailyRtcSessionHandle'

export function createDailyRtcAdapter({ capabilityOverrides = {} } = {}) {
  return {
    id: RTC_PROVIDERS.dailyCo,
    domain: 'rtc',
    compatibilityBridge: 'daily-co-fixture',
    supports: createDailyRtcAdapterCapabilities(capabilityOverrides),
    preload: preloadDailyRtcModule,
    CompatibilitySurface: DailyRtcCompatibilitySurface,
    createCompatibilityProps: createDailyRtcCompatibilityProps,
    createSession(initialConfig = {}) {
      return createDailyRtcSessionHandle({
        initialConfig,
      })
    },
    createPortBundle(options = {}) {
      return createDailyRtcPortBundle(options)
    },
  }
}

export const dailyRtcAdapter = createDailyRtcAdapter()

